// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.25664","1.25670"][{"118":0,"154":0,"780":1}[chunkId]] || "1.25671") + "/" + chunkId + ".js";
};